import adLibraryImageAdPreview from '../ad-library/image-191-100-ad-library';
import adLibraryTextAdPreview from '../ad-library/text-bing';

export const adLibraryTemplates = [
  adLibraryImageAdPreview,
  adLibraryTextAdPreview,
];
